import { useEffect, useRef, useState } from "react";
import {
  MaterialReactTable,
} from "material-react-table";
import { Box, Typography } from "@mui/material";
import { esES, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MRT_Localization_ES } from "material-react-table/locales/es";

interface GeneralTableInfiniteScrollProps <T> {
    columns: any;
    allData: T[];
    chunk: number;
    rowCount: number;
    enableHoverEffect?: boolean;
    paintRow?: (original: T) => string;
    isLoading?: boolean;
    customActionBtnSpace?: (original: T) => React.ReactNode;
    enableGlobalFilter?: boolean;
}

export default function GeneralTableInfiniteScroll<T>({ 
    columns,
    allData,
    chunk,
    rowCount,
    enableHoverEffect,
    paintRow,
    isLoading,
    customActionBtnSpace,
    enableGlobalFilter = false,
}: GeneralTableInfiniteScrollProps<T>) {
//   const columns = useMemo<MRT_ColumnDef<any>[]>(
//     () => [
//       { accessorKey: "id", header: "ID", size: 80 },
//       { accessorKey: "firstName", header: "Nombre" },
//       { accessorKey: "lastName", header: "Apellido" },
//       { accessorKey: "email", header: "Email" },
//     ],
//     [],
//   );

//   const [allData, setAllData] = useState<any[]>([]);
  const [visibleData, setVisibleData] = useState<any[]>([]);
//   const [chunk, setChunk] = useState(200);

  const containerRef = useRef<HTMLDivElement | null>(null);

  // Simula la carga inicial
  useEffect(() => {
    setVisibleData(allData.slice(0, chunk));
  }, []);

  useEffect(() => {
    setVisibleData(allData.slice(0, chunk));
  }, [allData]);

  // handler scroll
  const handleScroll = () => {
    if (!containerRef.current) return;
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setVisibleData((prev) =>
        allData.slice(0, Math.min(prev.length + chunk, allData.length)),
      );
    }
  };

  return (
    <LocalizationProvider
        dateAdapter={AdapterDayjs}
        localeText={
        esES.components.MuiLocalizationProvider.defaultProps.localeText
        }
        adapterLocale="es"
    >

            
        <MaterialReactTable
        columns={columns}
        data={visibleData}
        localization={MRT_Localization_ES}
        enableRowVirtualization
        enablePagination={false}
        muiTableContainerProps={{
            ref: containerRef,
            onScroll: handleScroll,
            sx: { maxHeight: 600 },
        }}
        displayColumnDefOptions={{ 'mrt-row-actions': { size: 120 } }}
        renderTopToolbarCustomActions={() => (
            <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
            Total de Registros: {rowCount}
            </Typography>
        )}
        muiTableBodyRowProps={({row}) => ({
            hover: enableHoverEffect,
            sx: {
            backgroundColor: paintRow?paintRow(row.original as T):undefined 
            }
        })}
        enableColumnActions={!!customActionBtnSpace}
        enableEditing={!!customActionBtnSpace}
        positionActionsColumn={!!customActionBtnSpace?'first':undefined}
        renderRowActions={({row}) => customActionBtnSpace?(
            <Box sx={{ display: 'flex', gap: '1rem' }}>
            {customActionBtnSpace(row.original as T)}
            </Box>
        ):null}
        state={{
            isLoading: isLoading,
            showProgressBars: isLoading,
        }}
        enableColumnFilters={false}
        enableGlobalFilter={enableGlobalFilter}
        initialState={{
            density: "comfortable",
        }}
        
        />
    </LocalizationProvider>
  );
}
